/* eslint-disable camelcase */
import { ISegment } from './types';

export const PurchasesDefault: ISegment = {
  consumer: {
    phone: {
      cosmos: true
    },
    modem: {
      cosmos: false
    },
    accessory: {
      cosmos: true
    },
    watches_and_bracelets: {
      cosmos: true
    },
    tablet: {
      cosmos: true
    },
    laptop: {
      cosmos: true
    },
    tv: {
      cosmos: true
    },
    optics_equipment: {
      cosmos: true
    }
  },
  business: {
    phone: {
      cosmos: true
    },
    modem: {
      cosmos: false
    },
    tablet: {
      cosmos: true
    },
    accessory: {
      cosmos: false
    },
    watches_and_bracelets: {
      cosmos: false
    },
    laptop: {
      cosmos: false
    },
    tv: {
      cosmos: true
    },
    optics_equipment: {
      cosmos: true
    }
  }
};
